import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { getToken } from '@shared/utils/token-storage';
import { isTokenExpired } from '@shared/utils/jwt';

export const authGuard: CanActivateFn = () => {
  const router = inject(Router);
  const token = getToken();
  if (!token || isTokenExpired(token)) {
    router.navigate(['/unauthorized']);
    return false;
  }
  return true;
};
